import * as dayjs from 'dayjs';
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { FileService } from '@service/file.service';

@Component({
  selector: 'app-capture-screen-modal',
  templateUrl: './capture-screen-modal.component.html',
  styleUrls: ['./capture-screen-modal.component.scss']
})
export class CaptureScreenModalComponent {
  captureCanvasData: string;

  constructor(private modalRef: BsModalRef, private fileService: FileService) {}

  get imageName(): string {
    const date: string = dayjs().format('DD-MM-YYYY');
    return `allianz-TA_${date}.png`;
  }

  download(): void {
    this.fileService.downloadFile(this.captureCanvasData, this.imageName);
    this.modalRef.hide();
  }
}
